<template>
  <v-tooltip :left="left" :top="top" :bottom="bottom" :right="right">
    <template v-slot:activator="{ on, attrs }">
      <v-icon :color="iconColor" v-on="on" v-bind="$attrs" :dark="dark">{{
        icon
      }}</v-icon>
    </template>
    <slot></slot>
  </v-tooltip>
</template>
<script>
export default {
  props: {
    position: {
      type: String,
      default: 'bottom',
    },
    dark: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: 'mdi-circle-medium',
    },
    iconColor: {
      type: String,
      default: '',
    },
  },
  components: {},
  filters: {},
  data() {
    return {}
  },
  created() {},
  computed: {
    left() {
      return this.position == 'left'
    },
    right() {
      return this.position == 'right'
    },
    top() {
      return this.position == 'top'
    },
    bottom() {
      return this.position == 'bottom'
    },
  },
  methods: {},
  watch: {},
}
</script>
<style scoped>
</style>